import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=71649319&scoped=true"
import script from "./PersonList.vue?vue&type=script&lang=js"
export * from "./PersonList.vue?vue&type=script&lang=js"
import style0 from "./PersonList.vue?vue&type=style&index=0&id=71649319&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71649319",
  null
  
)

export default component.exports